import {
    mapGetters,
    mapActions,
    mapMutations
  } from 'vuex'
  
  import * as managersManagerStore from '@/store/managersManager'
  
  export {
    managersManagerStore
  }
  
  /**
   * Search store.
   *
   * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
   */
  export const createManagersManagerMixin = (without = []) => {
    const actions = !without.includes('actions') ? mapActions(managersManagerStore.moduleName, Object.keys(managersManagerStore.actionTypes)) : {}
    const getters = !without.includes('getters') ? mapGetters(managersManagerStore.moduleName, Object.keys(managersManagerStore.getterTypes)) : {}
    const mutations = !without.includes('mutations') ? mapMutations(managersManagerStore.moduleName, Object.keys(managersManagerStore.mutationTypes)) : {}
  
    return {
      methods: {
        ...actions,
        ...mutations
      },
      computed: {
        ...getters
      }
    }
  }
  